// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioQuickDash {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"CUESTIONARIO QUICK DASH",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"CUESTIONARIO QUICK DASH PARA MIEMBROS SUPERIORES" ,bold:true },
                {valor:"", descripcion:"", tipo:0 ,label:"Seleccione el grado de dificultad en las siguientes actividades durante la semana pasada." ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"1. Abrir un frasco hermético o un nuevo tarro:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. Realizar los quehaceres del hogar más fuertes (Ej. lavar ventanas, pisos):" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. Transportar una bolsa de compras o un maletín:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. Lavarse su espalda:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. Usar un cuchillo para cortar alimentos:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:1 ,label:"6. Realizar actividades recreativas con esfuerzo de brazo, hombro o mano (Ej. Voley, básquet, aeróbicos, gimnasia):" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Incapaz"]},
                {valor:"", descripcion:"", tipo:0 ,label:"Seleccione el grado de dificultad en las siguientes actividades durante la semana pasada." ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"7. ¿Durante la semana pasada, en qué medida el problema del hombro o mano interfirió las actividades sociales con sus familiares, amigos, vecinos o grupos?:" ,data:["En absoluto","Poco","Moderadamente","Bastante","Demasiado"]},
                {valor:"", descripcion:"", tipo:1 ,label:"8. ¿Durante la semana pasada, tuvo que limitar su trabajo u otras actividades diarias a causa del problema del brazo, hombro o mano? :" ,data:["En absoluto","Poco","Moderadamente","Muy limitado","Incapaz"]},
                {valor:"", descripcion:"", tipo:0 ,label:"Califique la severidad de los siguientes síntomas durante la última semana" ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"9. Dolor en los brazos, hombros o manos:" ,data:["Ninguno","Leve","Mediano","Fuerte","Muy Fuerte"]},
                {valor:"", descripcion:"", tipo:1 ,label:"10. Hormigueo o como si le pincharan con agujas:" ,data:["Ninguno","Leve","Mediano","Fuerte","Muy Fuerte"]},
                {valor:"", descripcion:"", tipo:1 ,label:"11. ¿Durante la semana pasada, cuánta dificultad ha tenido para dormir debido al dolor de brazos, hombros o manos?:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Fuerte dificultad","Muy fuerte dificultad para dormir"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje" },
                {valor:"", descripcion:"", tipo:0 ,label:"INFLUENCIA DE LA DISCAPACIDAD EN EL TRABAJO" ,bold:true },
                {valor:"", descripcion:"", tipo:0 ,label:"¿Tiene alguna dificultad en lo siguiente?" ,bold:true },
                {valor:"", descripcion:"", tipo:1 ,label:"1. Al ejecutar su trabajo como regularmente lo hace:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Muy fuerte dificultad"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. Al ejecutar su trabajo habitual debido al dolor de los hombros, brazos o manos:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Muy fuerte dificultad"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. Al hacer tan bien su trabajo como usted quisiera:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Muy fuerte dificultad"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. Al ocupar el mismo tiempo que generalmente ocupa al hacer el trabajo:" ,data:["Ninguna dificultad","Poca dificultad","Mediana dificultad","Mucha dificultad","Muy fuerte dificultad"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Puntaje" },
                {valor:"", descripcion:"", tipo:5 ,label:"Calcular", click:4},
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoMusculoEsqueleticoQuickDash.js